import { render, staticRenderFns } from "./sotre.vue?vue&type=template&id=4e2fce59&scoped=true&"
import script from "./sotre.vue?vue&type=script&lang=js&"
export * from "./sotre.vue?vue&type=script&lang=js&"
import style0 from "./sotre.vue?vue&type=style&index=0&id=4e2fce59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2fce59",
  null
  
)

export default component.exports